import { useSelector } from 'react-redux';
import { isInSearchAndFilterMode as getIsInSearchAndFilterMode } from 'conversations-inbox-lib/thread-search-and-filtering/public/selectors';
import ErrorBoundary from 'conversations-error-reporting/error-boundaries/components/ErrorBoundary';
import ViewSelectorSidebar from './ViewSelectorSidebar';
import FilterSidebar from '../../thread-search-and-filtering/components/FilterSidebar';
import { jsx as _jsx } from "react/jsx-runtime";
const useComponent = () => {
  const isInSearchAndFilterMode = useSelector(getIsInSearchAndFilterMode);
  return {
    isInSearchAndFilterMode
  };
};
const InboxViewSelector = () => {
  const {
    isInSearchAndFilterMode
  } = InboxViewSelector.useComponent();
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    errorLoggingTitle: "InboxViewSelector",
    children: isInSearchAndFilterMode ? /*#__PURE__*/_jsx(FilterSidebar, {}) : /*#__PURE__*/_jsx(ViewSelectorSidebar, {})
  });
};
InboxViewSelector.displayName = 'InboxViewSelector';
InboxViewSelector.useComponent = useComponent;
export default InboxViewSelector;